import React from 'react';
import { useParams } from 'react-router-dom';
import exact from 'prop-types-exact';
import MusicSinglePage from '../../components/musics/containers/MusicSingleContainer';
import { getSingleMusicDataIfNeeded, setNotFound } from '../../components/musics/actions/MusicSingleActions';
import { fetchArtistsSlidesIfNeeded } from '../../components/artists/actions/ArtistsActions';

const MusicaInterna = () => {
    const { slug } = useParams();
    const [track, artist] = slug.split('+');

    return (
        <div className="pageWrapper tw-container tw-m-auto tw-px-5">
            <MusicSinglePage track={track} artist={artist} />
        </div>
    );
};

MusicaInterna.fetchData = (store, match) => {
    if (!match.params.slug) {
        // Note: This should never happen as the route without slug is handled by the musicasPage component...
        return store.dispatch(setNotFound(true));
    }

    const [track, artist] = match.params.slug.split('+');

    if (!track || !artist) {
        return store.dispatch(setNotFound(true));
    }

    const myPromises = [
        store.dispatch(getSingleMusicDataIfNeeded(artist, track)),
        store.dispatch(fetchArtistsSlidesIfNeeded()),
    ];

    return Promise.all(myPromises);
};

MusicaInterna.propTypes = exact({});

export default MusicaInterna;
